module.exports = __webpack_public_path__ + "media/audio54.23d330ca.mp3";